export default "__VITE_ASSET__BsQEYjBN__"